module.exports = __webpack_public_path__ + "img/home-btn-offeye.7fae2c06.svg";